import { AppRouteProps } from "@harea/component";
import React from "react";
import { RubriqueRoutes } from "./views/rubrique/RubriqueRoutes";
import { CotisationRoutes } from "../cotisation/CotisationRoutes";

const PayrollSettingsContainer = React.lazy(
  () => import("./container/PayrollSettingsContainer"),
);
export const PayrollSettingsRoutes = [
  {
    path: "settings",
    element: <PayrollSettingsContainer />,
    children: [...RubriqueRoutes, ...CotisationRoutes],
  },
] as Array<AppRouteProps>;
